export default __webpack_public_path__ + "static/media/sportsbra-medium-back-toobig.cfbb66ce.jpg";